export default class LabResult {
    constructor(immunizationName, immunizationNameFr, immunizationDate, locationName, immunizationStatus) {
        this.immunizationName = immunizationName
        this.immunizationNameFr = immunizationNameFr
        this.immunizationDate = immunizationDate
        this.locationName = locationName
        this.immunizationStatus = immunizationStatus
    }
}


